export function assetSlug(name) {
  return String(name || '').toLowerCase().replace(/_/g, '-');
}

export function manifestEntries(manifest) {
  return manifest?.bySlug || manifest || {};
}

export function hasManifestAsset(manifest, name) {
  const slug = assetSlug(name);
  return Boolean(manifestEntries(manifest)?.[slug]);
}

export function entityAssetPath(name, dir = 'south', frame = 0, { shiny = false, manifest = {} } = {}) {
  const slug = assetSlug(name);
  const entry = manifestEntries(manifest)?.[slug];
  if (shiny && entry && typeof entry.path === 'string') return entry.path;
  const prefix = shiny && entry ? `${slug}-shiny` : slug;
  return `public/assets/entities/${encodeURIComponent(prefix)}-${dir}-${frame}.png`;
}

export function portraitAssetPath(name, { shiny = false, manifest = {} } = {}) {
  if (!shiny) return null;
  const value = manifestEntries(manifest)?.[assetSlug(name)];
  if (typeof value === 'string') return value;
  if (value && typeof value.path === 'string') return value.path;
  return null;
}

export function shinyAssetClass(pokemon, manifest = {}) {
  if (!pokemon?.shiny) return '';
  return hasManifestAsset(manifest, pokemon.name) ? 'shiny shiny-real' : 'shiny shiny-fallback';
}
